const hearderPathIsBtn = [
  'detail',
  'alarm',
  'alocation',
  'report',
  'set',
  'subdetail',
  'airconditioner',
  'prefleet',
  'presubfleet',
  'feedbackDetail',
  'issueReportDetail',
  'groupLog',
]
const footerPathIsBtn = [
  '/home',
  '/vehicles/subdetail/page',
  '/home/detail/page',
  '/share/detail/page',
  '/vehicles/airconditioner/page'
]

const routerBackList = [
  {
    originalLink: '/home/alarm/page',
    superiorLink: '/home'
  },
  {
    originalLink: '/home/detail/page',
    superiorLink: '/home'
  },
  {
    originalLink: '/setting/set',
    superiorLink: '/users/account/index'
  },
  {
    originalLink: '/role/alocation/page',
    superiorLink: '/users/role'
  },
  // {
  //   originalLink: '/vehicles/airconditioner/page',
  //   superiorLink: '/vehicles/subdetail/page'
  // },
  {
    originalLink: '/vehicles/subdetail/page',
    superiorLink: '/vehicles/list'
  },
  {
    originalLink: '/data/report/page',
    superiorLink: '/data/reports'
  },
  {
    originalLink: '/other/issueReportDetail/page',
    superiorLink: '/other/issueReport'
  },
  {
    originalLink: '/prealarm/prefleet/page',
    superiorLink: '/data/prealarm'
  },
  {
    originalLink: '/prealarm/presubfleet/page',
    superiorLink: '/prealarm/prefleet/page'
  },
  {
    originalLink: '/other/feedbackDetail/page',
    superiorLink: '/other/feedbacklist'
  },
  {
    originalLink: '/vehicles/groupLog/log',
    superiorLink: '/vehicles/group'
  },
  {
    originalLink: '/vehicles/groupLog/logDetail',
    superiorLink: '/vehicles/groupLog/log'
  },
]

const RoterVehiclesBackList = [
  {
    fromKey: 'presubfleet',
    superiorLink: '/prealarm/presubfleet/page'
  },
  {
    fromKey: 'group',
    superiorLink: '/vehicles/group'
  },
  {
    fromKey: 'FeedbackDetail',
    superiorLink: '/other/feedbackDetail/page'
  },
  {
    fromKey: 'groupLog',
    superiorLink: '/vehicles/groupLog/logDetail'
  },
]

const asideMenuPath = [
  {
    childPath: 'alarm',
    parentPath: '/home'
  },
  {
    childPath: 'detail',
    parentPath: '/home'
  },
  {
    childPath: 'report',
    parentPath: '/data/reports'
  },
  {
    childPath: 'alocation',
    parentPath: '/users/role'
  },
  {
    childPath: 'subdetail',
    parentPath: '/vehicles/list'
  },
  {
    childPath: 'airconditioner',
    parentPath: '/vehicles/list'
  },
  {
    childPath: 'prefleet',
    parentPath: '/data/prealarm'
  },
  {
    childPath: 'presubfleet',
    parentPath: '/data/prealarm'
  },
  {
    childPath: 'groupLog',
    parentPath: '/vehicles/group'
  }
]

const collectAsideMenuPath = [
  {
    childPath: 'alarm',
    parentPath: 'home'
  },
  {
    childPath: 'detail',
    parentPath: 'home'
  },
  {
    childPath: 'report',
    parentPath: 'reports'
  },
  {
    childPath: 'alocation',
    parentPath: 'role'
  },
  {
    childPath: 'subdetail',
    parentPath: 'list'
  },
  {
    childPath: 'airconditioner',
    parentPath: 'list'
  },
  {
    childPath: 'prefleet',
    parentPath: 'prealarm'
  },
  {
    childPath: 'presubfleet',
    parentPath: 'prealarm'
  }
]

export {
  hearderPathIsBtn,
  routerBackList,
  RoterVehiclesBackList,
  asideMenuPath,
  collectAsideMenuPath,
  footerPathIsBtn
}
